import { consoleMsg, waitForContent } from "../shared/utility";
import { initializePage } from "../shared/page-init";
import { validatePage } from "../shared/validation";
import { wireIssueTextAlert, previous, handleSubmit } from "../shared/navigation";
import { storeDamageMarkers, restoreDamageMarkers } from "../shared/damage-map";
import { MarkerManager } from "../classes/marker-manager";
import { damageMgr } from "../web-components";
import { renderNavButtons } from "../shared/templates.js";

const app = window.app;

export class Exterior extends HTMLElement {
	async connectedCallback() {
		await waitForContent("exterior");
		this.innerHTML = app.content.exterior;

		// Render the navigation buttons component
		this.querySelector("#nav-slot").replaceWith(renderNavButtons("backButton2", "nextButton2"));

		this.addEventListener("ionViewWillEnter", async () => {
			const pageElement = this;
			await initializePage(2, pageElement);
		});
		this.addEventListener("ionViewDidEnter", async () => {
			// Add MarkerManager class to page
			const exteriorManager = new MarkerManager("myMap", "exterior", "damageAlert2", "removeMarkerButton");

			// --- Resolve damageAlert2 within THIS page element (shadow-DOM safe). Create if missing. ---
			let damageAlert2 = this.querySelector("#damageAlert2");
			if (!damageAlert2) {
				console.error("damageAlert2 not found in page template");
				return; // or throw
			}

			damageAlert2.inputs = [
				{ label: "Scrape", type: "radio", value: "scrape", checked: true },
				{ label: "Scratch", type: "radio", value: "scratch" },
				{ label: "Chip", type: "radio", value: "chip" },
				{ label: "Dent", type: "radio", value: "dent" },
				{ label: "Broken", type: "radio", value: "broken" },
				{ label: "Missing", type: "radio", value: "missing" },
				{ label: "Stained", type: "radio", value: "stained" },
				{ label: "Curb Rash", type: "radio", value: "curbRash" },
				{ label: "Loose", type: "radio", value: "loose" },
			];

			damageAlert2.buttons = [
				{
					text: "Cancel",
					role: "cancel",
					id: "damage-cancel-2",
					handler: () => {
						if (typeof resetDialogState === "function") resetDialogState();
					},
				},
				{
					text: "OK",
					role: "confirm",
					id: "damage-ok-2",
					// Selected value is also delivered to ionAlertDidDismiss; we set here for symmetry
					handler: (selected) => {
						app.content["damageAlert2Data"] = selected;
						return { confirm: true };
					},
				},
			];

			const resolvedDamageAlert2 = damageAlert2;
			const originalShowDamageDialog = exteriorManager.showDamageDialog?.bind(exteriorManager);
			exteriorManager.showDamageDialog = function () {
				if (resolvedDamageAlert2 && typeof resolvedDamageAlert2.present === "function") {
					resolvedDamageAlert2.present();
				} else if (originalShowDamageDialog) {
					originalShowDamageDialog();
				}
			};

			damageAlert2.addEventListener("ionAlertDidDismiss", (ev) => {
				if (ev.detail.role !== "confirm") {
					exteriorManager.resetState(); // always clear coords after any dismiss
					return;
				}

				// Radio returns either a string or { values: "..." } depending on Ionic internals
				const selected = ev.detail.data?.values ?? ev.detail.data;
				if (!selected) {
					console.warn("damageAlert2: no selection returned from alert");
					exteriorManager.resetState();
					return;
				}

				// Key must match what MarkerManager reads: this.alertId + "Data"
				app.content["damageAlert2Data"] = selected;

				// Place the marker at the coords captured by mapClicked
				exteriorManager.addMarkerFromDialog();
				exteriorManager.resetState();
			});

			// Function to add issue text alert handling and wire up event listener
			wireIssueTextAlert("issueTextAlert2", "deletePhotoButton");

			// Next/previous come from the flow manager — no vendor/direction logic needed.
			const currentRoute = app.routes.exterior;
			const nextPage = app.flowManager.getNext(currentRoute);
			const prevPage = app.flowManager.getPrevious(currentRoute);

			if (nextPage) app.state.nextButton.addEventListener("click", () => validatePage(nextPage.route));
			// MD ISSUE: SHOULDN'T I MOVE STORE DAMAGE MARKERS TO THE MARKER CLASS??  ALSO RESTORE DAMAGE MARKERS?
			app.state.backButton.addEventListener("click", () => storeDamageMarkers(app.state.damageMarkers));
			if (prevPage) app.state.backButton.addEventListener("click", () => previous(prevPage.route));

			await restoreDamageMarkers("myMap", "exterior");
			exteriorManager.updateRemoveButtonState();

			// Map functionality wasn't working when navigating back to page, so moving event listener bindings to here
			damageAlert2.addEventListener("ionAlertDidDismiss", (event) => consoleMsg(`Dismissed with role: ${event.detail.role}`), { once: true });

			const myMap = document.getElementById("myMap");
			const removeMarkerButton = document.getElementById("removeMarkerButton");

			myMap.addEventListener("click", exteriorManager.mapClicked.bind(exteriorManager));
			exteriorManager.updateRemoveButtonState();

			removeMarkerButton.addEventListener("click", () => exteriorManager.removeLastMarker());

			damageMgr.attachPhotoEventListeners(this, "photoRow", "takePhotoButton", "deletePhotoButton");
		});

		this.addEventListener("ionViewWillLeave", async () => {
			consoleMsg("PAGE 2: ION VIEW WILL LEAVE FIRED...");
			await handleSubmit("page2");
		});
	}
	disconnectedCallback() {}
}
